import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { toast, cssTransition } from 'react-toastify';

import Modal from '../Modal';
import 'animate.css/animate.min.css';
import 'react-toastify/dist/ReactToastify.css';

const base = 'sku-item';
const ITEM_STATUS = {
    WARMER: 'IN_WARMER',
    PRODUCTION: 'IN_PRODUCTION',
    ROUTE: 'ON_ROUTE',
};

@inject('LiveDispatchStore', 'UserStore', 'ScanningStore')
@observer
class SKUItem extends Component {
    state = {
        showRemakeModal: false,
        showErrorModal: false,
        showChoosePrintOrRemakeModal: false,
        action: ''
    };
    handleRemakeConfirmation = () => {
        const {
            LiveDispatchStore: { handleRemakeSKUItem },
            item,
        } = this.props;
        if (item.order_number) {
            this.setState({ action: "Remake" });
            handleRemakeSKUItem(item, this.remakeCallBack);
        } else {
            this.setState({ showErrorModal: true });
        }
    };

    handleReprintConfirmation = () => {
        const {
            LiveDispatchStore: { handleReprintSKUItem },
            item,
        } = this.props;
        if (item.order_number) {
            this.setState({ action: "Reprint" });
            handleReprintSKUItem(item, this.remakeCallBack);
        } else {
            this.setState({ showErrorModal: true});
        }
    };

    simulateScan = (item) => {
        const { LiveDispatchStore, ScanningStore } = this.props;
        const { handledScannedItem, handledScannedWarmerItem } = LiveDispatchStore;
        const { handleScan } = ScanningStore;
        handleScan("TA-" + item.sku + "-" + item.today_menu_id + "-" + item.incremental_number + "-" + item.order_number, handledScannedItem, handledScannedWarmerItem);
    }

    remakeCallBack = (status) => {
        const { item } = this.props;
        const slide = cssTransition({
            enter: 'animate__animated animate__slideInDown',
            exit: 'animate__animated animate__slideOutUp',
        });
        this.setState({ showRemakeModal: false, showChoosePrintOrRemakeModal: false });
        if (status === 'SUCCESS') {
            //show toast
            toast.configure();
            toast(this.toastContainer(), {
                toastId: `${item.sku}_${item.order_number}_${item.incremental_number}`,
                closeButton: this.closeButton,
                transition: slide,
                pauseOnHover: false,
                pauseOnFocusLoss: false,
                closeOnClick: false,
            });
        } else {
            this.setState({ showErrorModal: true });
        }
    };

    closeButton = () => {
        return (
            <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => toast.dismiss()}
            >
                <rect
                    x="1.06055"
                    width="19.7"
                    height="1.5"
                    transform="rotate(45 1.06055 0)"
                    fill="white"
                />
                <rect
                    width="19.7"
                    height="1.5"
                    transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.9302 0)"
                    fill="white"
                />
            </svg>
        );
    };
    toastContainer = () => {
        const { item } = this.props;
        const itemSKUToShow =
            item.item_type === 'Addons' ? item.sku : item.sku.split('_')[0];
        return (
            <div className={`${base}__customToast`}>
                <svg
                    width="30"
                    height="21"
                    viewBox="0 0 30 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.776855 9.63637L11.8183 20.6778L14.1325 18.3636L3.09102 7.3222L0.776855 9.63637Z"
                        fill="#18D665"
                    />
                    <path
                        d="M11.8181 20.6778L29.405 3.09092L27.0908 0.776749L9.50391 18.3636L11.8181 20.6778Z"
                        fill="#18D665"
                    />
                </svg>
                <p className="message">{itemSKUToShow} {this.state.action} successful</p>
            </div>
        );
    };

    closeModal = () => {
        this.setState({showChoosePrintOrRemakeModal: false})
    }

    render() {
        const {
            item,
            isFirstItem, 
            isLastItem, 
            isLastCategory, 
            type,
            isIncomingOrder,
            isPackingV2 = false,
            disableActions = false,
            UserStore: { selectedHub },
            LiveDispatchStore: { remakeLoading, SKURemakeErrorMsg },
        } = this.props;
        const isOnDemandProduction = selectedHub.isOnDemandProduction;
        const { showRemakeModal, showErrorModal, showChoosePrintOrRemakeModal, action } = this.state;
        const itemSKUToShow =
            item.item_type === 'Addons' ? item.sku : item.sku.split('_')[0];
        const remakeIconSrc =
            item.status === ITEM_STATUS.PRODUCTION
                ? 'https://image.popcontent.link/remake_complete_black.png'
                : 'https://image.popcontent.link/remake_complete_black.png';
        const hideBottomBorder = (type === 'meals' && !item.lastItemOfGroup) || isLastItem ? true: false;
        const isValueMealItem = type === 'meals' && !item.isMainItem;
        const remark = item.remark;
        const isActionableItem =
            isOnDemandProduction && (type === 'meals' && item.isMainItem || type !== 'meals');
        const canTriggerAction = !disableActions && isActionableItem;

        return (
            <Fragment>
                <div className={`${base}__order_item_card ${(isLastItem && !isLastCategory) ? 'with-border-bottom' : ''} ${isValueMealItem ? 'value_meal_item_card' : ''}`}>
                    <div>
                    {isFirstItem && type == "meals" ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="45" viewBox="0 1 55 55" fill="none" className="logo-svg">
                            <path d="M51.2 26.6921C51.1609 25.3859 50.7873 24.1116 50.115 22.991C49.4427 21.8705 48.4941 20.9412 47.36 20.2921C47.088 18.4338 46.1554 16.7358 44.7331 15.5094C43.3108 14.283 41.494 13.6103 39.616 13.6147C38.8958 13.6135 38.1786 13.7067 37.4827 13.8921C36.0143 12.4902 34.0622 11.7079 32.032 11.7079C30.0018 11.7079 28.0497 12.4902 26.5813 13.8921C25.8854 13.7067 25.1682 13.6135 24.448 13.6147C22.5626 13.6 20.7356 14.268 19.3043 15.4954C17.8731 16.7227 16.9343 18.4265 16.6613 20.2921C15.5232 20.9386 14.5704 21.8667 13.8942 22.9874C13.218 24.1081 12.8412 25.3838 12.8 26.6921C12.2342 26.6921 11.6916 26.9168 11.2915 27.3169C10.8914 27.717 10.6667 28.2596 10.6667 28.8254C10.6668 32.5701 11.6525 36.2488 13.5249 39.4918C15.3973 42.7347 18.0903 45.4277 21.3333 47.3001V50.1587C21.3333 50.7245 21.5581 51.2672 21.9582 51.6672C22.3582 52.0673 22.9009 52.2921 23.4667 52.2921H40.5333C41.0991 52.2921 41.6417 52.0673 42.0418 51.6672C42.4419 51.2672 42.6667 50.7245 42.6667 50.1587V47.3001C45.9097 45.4277 48.6027 42.7347 50.4751 39.4918C52.3474 36.2488 53.3332 32.5701 53.3333 28.8254C53.3333 28.2596 53.1086 27.717 52.7085 27.3169C52.3084 26.9168 51.7658 26.6921 51.2 26.6921ZM17.0667 26.6921C17.1208 26.0181 17.3752 25.3756 17.7972 24.8473C18.2191 24.3189 18.7893 23.9287 19.4347 23.7267L21.2053 23.1721L20.864 21.3587C20.8696 20.8993 20.9656 20.4454 21.1466 20.0231C21.3276 19.6007 21.59 19.2181 21.9188 18.8972C22.2477 18.5763 22.6365 18.3233 23.0632 18.1527C23.4898 17.982 23.9459 17.8971 24.4053 17.9027C25.0214 17.8992 25.6291 18.0456 26.176 18.3294L27.904 19.2894L28.9707 17.6467C29.3042 17.1495 29.7551 16.7421 30.2834 16.4603C30.8117 16.1786 31.4012 16.0312 32 16.0312C32.5987 16.0312 33.1883 16.1786 33.7166 16.4603C34.2449 16.7421 34.6957 17.1495 35.0293 17.6467L36.096 19.2894L37.824 18.3294C38.3709 18.0456 38.9786 17.8992 39.5947 17.9027C40.5174 17.8911 41.4078 18.2423 42.0741 18.8807C42.7404 19.5191 43.1294 20.3937 43.1573 21.3161L42.816 23.1294L44.5653 23.7267C45.2106 23.9287 45.7809 24.3189 46.2028 24.8473C46.6247 25.3756 46.8791 26.0181 46.9333 26.6921H17.0667Z" fill="#131415"/>
                        </svg>
                    : ""}
                    {isFirstItem && type == "addons" ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 5 50 50" fill="none" className="logo-svg">
                            <path d="M36.9231 18.8712V15.5891C36.9231 15.1539 36.7503 14.7365 36.4425 14.4287C36.1347 14.121 35.7173 13.9481 35.2821 13.9481C34.8469 13.9481 34.4295 14.121 34.1217 14.4287C33.8139 14.7365 33.641 15.1539 33.641 15.5891V32.8202H35.0195C35.7021 32.8196 36.3675 32.6062 36.9231 32.2097V18.8712ZM42.1089 27.0765C41.4263 27.0771 40.7609 27.2905 40.2052 27.687V27.0765H43.4874V18.8712C43.4874 18.436 43.3145 18.0186 43.0067 17.7108C42.6989 17.4031 42.2815 17.2302 41.8463 17.2302C41.4111 17.2302 40.9937 17.4031 40.6859 17.7108C40.3781 18.0186 40.2052 18.436 40.2052 18.8712V27.0765H42.1089ZM45.9489 27.0765C46.6493 27.0765 47.341 27.2309 47.9749 27.5287C48.6088 27.8264 49.1693 28.2602 49.6164 28.7992C50.0636 29.3382 50.3865 29.9691 50.5621 30.6471C50.7377 31.3251 50.7618 32.0334 50.6325 32.7217L47.5211 49.316C47.3098 50.4448 46.7106 51.4641 45.8271 52.1977C44.9437 52.9313 43.8316 53.333 42.6832 53.3333H21.3167C20.1684 53.333 19.0563 52.9313 18.1729 52.1977C17.2894 51.4641 16.6902 50.4448 16.4789 49.316L13.3675 32.7217C13.2382 32.0334 13.2623 31.3251 13.4379 30.6471C13.6135 29.9691 13.9364 29.3382 14.3835 28.7992C14.8307 28.2602 15.3912 27.8264 16.0251 27.5287C16.659 27.2309 17.3507 27.0765 18.0511 27.0765H17.2305V18.8712C17.2307 17.679 17.6635 16.5272 18.4487 15.63C19.2338 14.7327 20.3179 14.1508 21.4997 13.9924C22.6814 13.834 23.8804 14.1099 24.8742 14.7687C25.8679 15.4276 26.5887 16.4247 26.9029 17.5748C28.0089 17.1347 29.2371 17.1114 30.3589 17.5092V15.5891C30.3591 14.3969 30.792 13.2451 31.5771 12.3478C32.3623 11.4506 33.4463 10.8687 34.6281 10.7103C35.8098 10.5519 37.0089 10.8278 38.0026 11.4866C38.9963 12.1455 39.7172 13.1425 40.0313 14.2927C40.7782 13.9965 41.5863 13.8876 42.3849 13.9755C43.1836 14.0634 43.9486 14.3455 44.6132 14.797C45.2778 15.2486 45.8218 15.856 46.1976 16.5662C46.5735 17.2764 46.7698 18.0677 46.7695 18.8712V27.0765H45.9489ZM40.1429 33.6407C39.528 34.4087 38.7483 35.0287 37.8615 35.4548C36.9746 35.8809 36.0034 36.1022 35.0195 36.1023H28.9805C27.9971 36.1017 27.0265 35.8802 26.1403 35.4541C25.2541 35.028 24.4749 34.4083 23.8604 33.6407H23.7947V33.5619C23.6063 33.3183 23.4352 33.0616 23.2827 32.7939L21.8911 30.3586H18.0511C17.8326 30.3582 17.6168 30.406 17.419 30.4986C17.2212 30.5913 17.0463 30.7264 16.9068 30.8945C16.7673 31.0625 16.6666 31.2593 16.6119 31.4708C16.5572 31.6823 16.5499 31.9032 16.5905 32.1178L18.1069 40.2049H45.8931L47.4095 32.1178C47.4501 31.9032 47.4428 31.6823 47.3881 31.4708C47.3334 31.2593 47.2327 31.0625 47.0932 30.8945C46.9537 30.7264 46.7788 30.5913 46.581 30.4986C46.3832 30.406 46.1674 30.3582 45.9489 30.3586H42.1089L40.7173 32.7939C40.5642 33.0613 40.3931 33.3178 40.2052 33.5619V33.6407H40.1429ZM30.3589 22.1534C30.3589 21.7181 30.186 21.3007 29.8783 20.993C29.5705 20.6852 29.1531 20.5123 28.7179 20.5123C28.2827 20.5123 27.8652 20.6852 27.5575 20.993C27.2497 21.3007 27.0768 21.7181 27.0768 22.1534V32.2097C27.6325 32.6062 28.2979 32.8196 28.9805 32.8202H30.3589V22.1534ZM23.7947 27.0765V18.8712C23.7947 18.436 23.6218 18.0186 23.3141 17.7108C23.0063 17.4031 22.5889 17.2302 22.1537 17.2302C21.7184 17.2302 21.301 17.4031 20.9933 17.7108C20.6855 18.0186 20.5126 18.436 20.5126 18.8712V27.0765H23.7947ZM23.7947 27.0765H21.8911C22.5737 27.0771 23.2391 27.2905 23.7947 27.687V27.0765ZM18.7239 43.487L19.702 48.7121C19.7725 49.0887 19.9725 49.4288 20.2674 49.6734C20.5624 49.918 20.9336 50.0516 21.3167 50.0512H42.6832C43.0664 50.0516 43.4376 49.918 43.7325 49.6734C44.0275 49.4288 44.2275 49.0887 44.298 48.7121L45.2761 43.487H18.7239Z" fill="#131415"/>
                        </svg>
                    : ""}
                    {isFirstItem && type == "drinks" ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="-1 -3 20 45" fill="none" className="logo-svg">
                            <path d="M1.06668 14.4666H30.9333" stroke="#131415" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M5.49661 16.7525C5.47566 16.4602 5.51514 16.1668 5.61259 15.8905C5.71005 15.6141 5.86338 15.3608 6.06303 15.1464C6.26269 14.9319 6.50439 14.7609 6.77305 14.6439C7.04172 14.527 7.3316 14.4666 7.62461 14.4666H24.3755C24.6685 14.4666 24.9582 14.527 25.2268 14.6438C25.4954 14.7607 25.7371 14.9317 25.9367 15.146C26.1363 15.3604 26.2897 15.6135 26.3872 15.8897C26.4847 16.1659 26.5243 16.4593 26.5035 16.7514L24.6753 42.3514C24.637 42.8897 24.3961 43.3934 24.0013 43.7611C23.6064 44.1289 23.0869 44.3333 22.5473 44.3333H9.45288C8.91329 44.3333 8.39375 44.1289 7.99889 43.7611C7.60403 43.3934 7.36319 42.8897 7.32488 42.3514L5.49661 16.7525Z" fill="#131415" stroke="#131415" strokeWidth="2"/>
                            <path d="M16.0001 8.06667V3.80001C16.0001 3.23421 16.2249 2.69159 16.625 2.29151C17.025 1.89143 17.5677 1.66667 18.1335 1.66667H21.3335" stroke="#131415" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M6.10357 9.84897C6.18661 9.35103 6.44354 8.89868 6.82868 8.57232C7.21382 8.24597 7.70222 8.06676 8.20704 8.06657H23.7932C24.2982 8.06651 24.7868 8.2456 25.1722 8.57198C25.5575 8.89835 25.8146 9.35085 25.8977 9.84897L26.6668 14.4666H5.33344L6.10357 9.84897Z" stroke="#131415" strokeWidth="2"/>
                        </svg>
                    : ""}
                    {isFirstItem && type == "cutlery" ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" viewBox="0 5 55 45" fill="none" className="logo-svg">
                            <path d="M49.0667 34.1333V49.0667C49.0667 50.1982 48.6172 51.2835 47.817 52.0836C47.0168 52.8838 45.9316 53.3333 44.8 53.3333C43.6684 53.3333 42.5832 52.8838 41.783 52.0836C40.9829 51.2835 40.5333 50.1982 40.5333 49.0667V38.4H36.2667V17.0667C36.2667 15.3693 36.941 13.7414 38.1412 12.5412C39.3414 11.3409 40.9693 10.6667 42.6667 10.6667H49.0667V34.1333ZM19.2 32C18.0684 32 16.9832 31.5505 16.183 30.7503C15.3829 29.9502 14.9333 28.8649 14.9333 27.7333V12.8C14.9333 12.2342 15.1581 11.6916 15.5582 11.2915C15.9583 10.8914 16.5009 10.6667 17.0667 10.6667C17.6325 10.6667 18.1751 10.8914 18.5752 11.2915C18.9753 11.6916 19.2 12.2342 19.2 12.8V21.3333H21.3333V12.8C21.3333 12.2342 21.5581 11.6916 21.9582 11.2915C22.3583 10.8914 22.9009 10.6667 23.4667 10.6667C24.0325 10.6667 24.5751 10.8914 24.9752 11.2915C25.3753 11.6916 25.6 12.2342 25.6 12.8V21.3333H27.7333V12.8C27.7333 12.2342 27.9581 11.6916 28.3582 11.2915C28.7583 10.8914 29.3009 10.6667 29.8667 10.6667C30.4325 10.6667 30.9751 10.8914 31.3752 11.2915C31.7753 11.6916 32 12.2342 32 12.8V27.7333C32 28.8649 31.5505 29.9502 30.7503 30.7503C29.9502 31.5505 28.8649 32 27.7333 32V49.0667C27.7333 50.1982 27.2838 51.2835 26.4837 52.0836C25.6835 52.8838 24.5983 53.3333 23.4667 53.3333C22.3351 53.3333 21.2498 52.8838 20.4497 52.0836C19.6495 51.2835 19.2 50.1982 19.2 49.0667V32Z" fill="#131415"/>
                        </svg>
                    : ""}
                </div>
                {
                    isIncomingOrder ? (
                        <div className={`${base}__sku_items item-status in_production ${hideBottomBorder ? '' : 'with-border-bottom'}`}>
                            <div className="sku_and_remark">
                                <div className={`${isValueMealItem ? 'value_meal_item' : ''}`}>{itemSKUToShow} </div>
                            </div>
                        </div>
                    ) : (
                        <div
                        className={`${base}__sku_items item-status ${
                            (item.status !== ITEM_STATUS.ROUTE)
                                ? item.status.toLowerCase()
                                : item.item_type === 'Addons'
                                ? 'on_route'
                                : 'on_route'
                        }  ${hideBottomBorder ? '' : 'with-border-bottom'}`}
                        onClick={() => {
                            if (canTriggerAction && !isPackingV2) {
                                this.setState({ showChoosePrintOrRemakeModal: true });
                            }
                        }}
                    >

                        <div className="sku_and_remark">
                            <div className={`${isValueMealItem ? 'value_meal_item' : ''}`}>{itemSKUToShow} </div>

                            {remark && (
                                <div className='remark'> Customer Request: {remark} </div>
                            )}
                        </div>
                        
                        {isActionableItem && (
                            <svg
                                className="remake_icon"
                                style={{width: '22.5px', height: '20px', cursor: 'pointer'}}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    if (canTriggerAction) {
                                        this.setState({ showChoosePrintOrRemakeModal: true });
                                    }
                                }}
                            >
                                <use xlinkHref={`#icon-print-medium`} />
                            </svg>
                        )}
    
                        {item.status === ITEM_STATUS.IN_WARMER && (
                            <span className="cycle-no">
                                {item.cycle_number ? item.cycle_number : ''}
                            </span>
                        )}
                    </div>
                    )
                }
            </div>
                {(showChoosePrintOrRemakeModal && !isIncomingOrder) && (
                    <Modal
                        className={`${base}__action-modal`}
                        width={'45%'}
                        padding={'0px'}
                        borderRadius={'0px'}
                        onBackdropClicked={this.closeModal}
                    >
                        <div className={`${base}__remake_modal`}>
                            <h3 className={`${base}__remake_modal_title`}>
                                {itemSKUToShow}
                            </h3>
                            <p className={`${base}__remake_modal_desc`}>
                                What you want to do?
                            </p>
                            <div className={`${base}__submit_cancel`}>
                                <button
                                    className={`${base}__button cancel`}
                                    onClick={() => {
                                        this.setState({
                                            showRemakeModal: true,
                                            showChoosePrintOrRemakeModal: false
                                        });
                                    }}
                                >
                                    REMAKE
                                </button>
                                <button
                                    className={`${base}__button confirm`}
                                    onClick={this.handleReprintConfirmation}
                                >
                                    REPRINT
                                </button>
                            </div>
                        </div>
                    </Modal>
                )}
                {(showRemakeModal && !isIncomingOrder) && (
                    <Modal className={`${base}__action-modal`} width={'45%'} padding={'0px'} borderRadius={'0px'}>
                        {remakeLoading ? (
                            <div className={`${base}__remake_modal`}>
                                Loading..
                            </div>
                        ) : (
                            <div className={`${base}__remake_modal`}>
                                <h3 className={`${base}__remake_modal_title`}>
                                    Remake: {itemSKUToShow}
                                </h3>
                                <p className={`${base}__remake_modal_desc`}>
                                    You are taking one {itemSKUToShow} from
                                    stock.
                                </p>
                                <div className={`${base}__submit_cancel`}>
                                    <button
                                        className={`${base}__button cancel`}
                                        onClick={() => {
                                            this.setState({
                                                showRemakeModal: false,
                                                showChoosePrintOrRemakeModal: false
                                            });
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className={`${base}__button confirm`}
                                        onClick={this.handleRemakeConfirmation}
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        )}
                    </Modal>
                )}
                {showErrorModal && (
                    <Modal className={`${base}__action-modal`} width={'46%'} padding={'0px'} borderRadius={'0px'}>
                        <div className={`${base}__remake_modal`}>
                            <div
                                className={`${base}__remake_modal_title remake-error`}
                            >
                                {itemSKUToShow} <br/> {action} Failed
                            </div>
                            <p
                                className={`${base}__remake_modal_desc remake-error`}
                            >
                                {SKURemakeErrorMsg ||
                                    'Error occurred. Please try again or contact IT'}
                            </p>
                            <button
                                className={`${base}__button dismiss`}
                                onClick={() => {
                                    this.setState({
                                        showErrorModal: false,
                                        showChoosePrintOrRemakeModal: false
                                    });
                                }}
                            >
                                Dismiss
                            </button>
                        </div>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

export default SKUItem;
